import React from 'react';
import { CtaBlock } from './CtaBlock';
export function MidPageCtaSection() {
  return <section className="w-full bg-editorial-bg py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bg to-editorial-bgAlt" data-id="element-88">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-89">
        <h2 className="text-2xl md:text-3xl font-serif text-editorial-text leading-tight mb-10 max-w-2xl" data-id="element-90">
          16 chapters. Every mechanism documented.
          <br className="hidden md:block" data-id="element-91" />
          The full story — delivered to your inbox in 60 seconds.
        </h2>

        <div className="w-full max-w-md" data-id="element-92">
          <CtaBlock buttonText="Read the Full Book — $13.99" data-id="element-93" />
        </div>
      </div>
    </section>;
}